export default {
  title: 'Get the best experience on our mobile app',
  description: 'Save time, earn rewards, get notified about more deals and more',
  buttons: {
    download: 'Open the {{name}} app',
  },
};
